/* ============================================
   FK U** RINGS — PAGE 1 — Interactions
   ============================================ */

(function() {

  /* Add body class to lock scroll */
  document.body.classList.add("fku-rings-page");

  /* ============================================
     ZONE 0 — HERO GATE
     Pure addition on top of the existing Zone 1/2 logic
     below (untouched). gateActive only gates the wheel/
     keyboard/touch handlers so a gesture during the gate
     can't silently advance ring chapters behind it — the
     gate itself is dismissed ONLY by a click, per spec.
     ============================================ */
  const heroGate = document.getElementById("fkuHeroGate");
  let gateActive = !!heroGate;

  const persistentCta = document.getElementById("fkuPersistentCta");
  const productUrl = persistentCta ? persistentCta.getAttribute("href") : null;
  const labelGate = persistentCta ? persistentCta.dataset.labelGate : "";
  const labelNormal = persistentCta ? persistentCta.dataset.labelNormal : "";

  function dismissGate() {
    if (!gateActive) return;
    gateActive = false;

    if (heroGate) {
      heroGate.classList.add("dismissed");
      setTimeout(function() {
        if (heroGate) heroGate.style.display = "none";
      }, 700);
    }

    /* Swap the persistent CTA from "Don't touch :)" back to its
       normal "PICK ONE →" behavior — same element, same slot. */
    if (persistentCta) {
      persistentCta.textContent = labelNormal;
      persistentCta.setAttribute("href", productUrl);
    }
  }

  if (heroGate) {
    heroGate.addEventListener("click", dismissGate);
  }

  if (persistentCta) {
    persistentCta.addEventListener("click", function(e) {
      if (gateActive) {
        e.preventDefault();
        dismissGate();
      }
      /* once dismissed, href is already the real product URL —
         default navigation proceeds normally, no handler needed */
    });
  }

  const zone1 = document.getElementById("fkuZone1");
  const zone2 = document.getElementById("fkuZone2");
  const titles = document.querySelectorAll(".fku-title-item");
  const panels = document.querySelectorAll(".fku-panel");
  const hint = document.getElementById("fkuHint");
  const progressArc = document.getElementById("fkuProgressArc");
  const posDot = document.getElementById("fkuPosDot");

  const total = 6;
  let current = 0;
  let cooldown = false;
  let exited = false;

  /* Calculate arc path for progress around outer ring */
function describeArc(cx, cy, r, startAngle, endAngle) {
  const start = polarToCartesian(cx, cy, r, startAngle);
  const end = polarToCartesian(cx, cy, r, endAngle);
  const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
  return [
    "M", start.x, start.y,
    "A", r, r, 0, largeArcFlag, 1, end.x, end.y
  ].join(" ");
}

  function polarToCartesian(cx, cy, r, angleInDegrees) {
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
      x: cx + (r * Math.cos(angleInRadians)),
      y: cy + (r * Math.sin(angleInRadians))
    };
  }

/* Update progress arc and dot based on current section
   Arc starts at bottom of visible ring (180°) and grows
   counterclockwise toward top (0°/360°), divided in 6 segments */
function updateProgress(sectionIndex) {
  const startAngle = 270;
  const endAngleFull = 360; /* sweeps from 270 to 360 (bottom to top going right side) */
  const totalSweep = endAngleFull - startAngle; /* 180 degrees */
  const segmentAngle = (sectionIndex + 1) / total * totalSweep;
  const currentEndAngle = startAngle + segmentAngle;

  if (sectionIndex < 0) {
    progressArc.setAttribute("opacity", "0");
    posDot.setAttribute("opacity", "0");
    return;
  }

  progressArc.setAttribute("opacity", "1");
  progressArc.setAttribute("d", describeArc(500, 500, 472, startAngle, currentEndAngle));

  posDot.setAttribute("opacity", "1");
  const dotPos = polarToCartesian(500, 500, 472, currentEndAngle);
  posDot.setAttribute("cx", dotPos.x);
  posDot.setAttribute("cy", dotPos.y);
}

  /* Go to specific section */
  function go(index) {
    if (index < 0 || index >= total) return;
    if (index === current) return;

    /* Update titles */
    titles.forEach(function(t, i) {
      t.classList.toggle("active", i === index);
    });

    /* Update panels */
    panels.forEach(function(p, i) {
      p.classList.remove("on", "out");
      if (i === current) {
        p.classList.add("out");
      }
      if (i === index) {
        p.classList.add("on");
      }
    });

    current = index;
    updateProgress(index);

    /* Hide hint after first interaction */
    if (hint && !hint.classList.contains("gone")) {
      hint.classList.add("gone");
    }
  }

  /* Advance forward or backward */
  function advance(direction) {
    if (cooldown || exited) return;

    const next = current + direction;

    /* If at last section and going forward, exit Zone 1 */
    if (next >= total) {
      exitZone1();
      return;
    }

    if (next < 0) return;

    go(next);
    cooldown = true;
    setTimeout(function() { cooldown = false; }, 700);
  }

  /* Exit Zone 1, reveal Zone 2 */
  function exitZone1() {
    if (exited) return;
    exited = true;

  /* Detach CTA from Zone 1 before transform starts */
  const cta = document.querySelector(".fku-persistent-cta");
  if (cta) document.body.appendChild(cta);

  zone1.classList.add("exiting");

  setTimeout(function() {
    zone1.classList.add("gone");
    zone2.classList.add("revealed");
    /* "fku-rings-page" is intentionally KEPT here, not removed.
       CSS already has body.fku-rings-page.unlocked specifically to
       lift the scroll-lock while staying on this page (see
       page-fku-rings.css) — removing the class was unnecessary for
       that, and had the side effect of also stripping the page's
       cursor identity the moment Zone 2 (the gallery) appeared,
       which is why it fell back to the site default there. */
    document.body.classList.add("unlocked");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, 600);
}

  /* Click on title */
 titles.forEach(function(t) {
  t.addEventListener("click", function() {
    if (gateActive) return;
    const index = parseInt(t.dataset.section);
    go(index);
    cooldown = true;
    setTimeout(function() { cooldown = false; }, 1000);
  });
});

/* Scroll wheel — locks only during Zone 1 section navigation */
let wheelLock = false;
let wheelEndTimer = null;

window.addEventListener("wheel", function(e) {
  if (gateActive) {
    /* Gate is up: swallow the gesture so Zone 1 underneath can't
       silently advance chapters. Dismissal is click-only per spec,
       so this does NOT call dismissGate(). */
    e.preventDefault();
    return;
  }

  if (exited) {
    /* Zone 2 — normal scroll, no interference */
    return;
  }

  e.preventDefault();

  if (wheelEndTimer) clearTimeout(wheelEndTimer);

  wheelEndTimer = setTimeout(function() {
    wheelLock = false;
  }, 300);

  if (wheelLock || cooldown) return;

  wheelLock = true;
  advance(e.deltaY > 0 ? 1 : -1);
}, { passive: false });

  /* Keyboard */
  window.addEventListener("keydown", function(e) {
    if (gateActive) return;
    if (exited) return;
    if (e.key === "ArrowDown" || e.key === "ArrowRight") {
      advance(1);
    } else if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
      advance(-1);
    }
  });

  /* Touch / swipe — mobile navigation between sections */
  var touchStartY = 0;
  var touchStartX = 0;
  window.addEventListener("touchstart", function(e) {
    touchStartY = e.touches[0].clientY;
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  window.addEventListener("touchend", function(e) {
    if (gateActive) return;
    if (exited) return;
    var deltaY = touchStartY - e.changedTouches[0].clientY;
    var deltaX = touchStartX - e.changedTouches[0].clientX;
    /* Only act on vertical swipes larger than 30px */
    if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 30) {
      advance(deltaY > 0 ? 1 : -1);
    }
  }, { passive: true });

})();
